module.exports = __webpack_public_path__ + "static/thanksgiving-pumpkins-8b4ddfad8735b0d6a4c13dc12f6111f1.jpg";